import { OrchidDriveEntryKeys } from "../types";

type OrchidDriveEntryKeysReducerResetAction = {
  type: "reset";
};

type OrchidDriveEntryKeysReducerNeedKeysAction = {
  type: "need_keys";
  entryKeysNeeded: string[];
};

type OrchidDriveEntryKeysReducerAddKeysAction = {
  type: "add_keys";
  entryKeys: {
    [key: string]: OrchidDriveEntryKeys;
  };
};

type OrchidDriveEntryKeysState = {
  [key: string]: null | OrchidDriveEntryKeys;
};

export default function OrchidDriveEntryKeysReducer(
  state: OrchidDriveEntryKeysState,
  action:
    | OrchidDriveEntryKeysReducerResetAction
    | OrchidDriveEntryKeysReducerNeedKeysAction
    | OrchidDriveEntryKeysReducerAddKeysAction,
) {
  switch (action.type) {
    case "reset": {
      if (Object.keys(state).length === 0) return state;
      return {};
    }
    case "need_keys": {
      if (action.entryKeysNeeded.every((entryId) => entryId in state)) {
        return state;
      }
      const newState = { ...state };
      for (const entryId of action.entryKeysNeeded) {
        const existing = state[entryId];
        if (!existing) {
          newState[entryId] = null;
        }
      }
      return newState;
    }
    case "add_keys": {
      if (Object.keys(action.entryKeys).every((entryId) => !!state[entryId])) {
        return state;
      }
      const newState = { ...state };
      for (const [entryId, keys] of Object.entries(action.entryKeys)) {
        const existing = state[entryId];
        if (!existing) {
          newState[entryId] = keys;
        }
      }
      return newState;
    }
  }
  throw new Error(`unexpected action type: ${action}`);
}
